import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/brand.css';

/*
 * Ordem de carregamento (importa!):
 * data → calc → ui → login → telas → App
 * Os módulos abaixo registram dados e componentes em `window`
 * (mesmo runtime do protótipo). O App é montado por último.
 */
import './lib/data.js';
import './lib/calc.js';
import './services/indices.js';
import './services/api.js';
import './components/ui.jsx';
import './components/dialogs.jsx';
import './components/login.jsx';
import './screens/screen-dashboard.jsx';
import './screens/screen-monitor.jsx';
import './screens/screen-contratos.jsx';
import './screens/screen-detalhe.jsx';
import './screens/screen-alertas.jsx';
import './screens/screen-indices.jsx';
import './screens/screen-arquivos.jsx';
import './screens/screen-aditivos.jsx';
import './screens/screen-societarios.jsx';
import './screens/screen-alvaras.jsx';
import './screens/screen-certificados.jsx';
import './screens/screen-empresas.jsx';
import './screens/screen-usuarios.jsx';
import App from './App.jsx';

createRoot(document.getElementById('root')).render(<App />);
